// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { BackIcon, Box, Button, IconButton, Typography } from "@carrotfertility/carotene-core"
import React from "react"

// Placeholder — insurance verification isn't built yet. Deliberately not sharing
// PaymentStep's layout: that layout (card auth copy, "authorized amount") is
// payment-specific, and we don't yet know what this step's real design should be.
type InsuranceDetailsStepProps = {
  onBack: () => void
}

// Continue is type="submit" — it's picked up by the shared form's onSubmit in
// BookingForm.tsx like every other step, even though this step has no fields.
export function InsuranceDetailsStep({ onBack }: InsuranceDetailsStepProps) {
  return (
    <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.tokens.spacing.lg })}>
      <IconButton aria-label="Back" size="small" color="secondary" onClick={onBack} sx={{ inlineSize: "fit-content" }}>
        <BackIcon />
      </IconButton>
      <Typography variant="h1">Insurance details</Typography>
      <Typography>Insurance verification isn&apos;t built yet — this is a placeholder for that flow.</Typography>
      <Button type="submit" color="secondary">
        Continue
      </Button>
    </Box>
  )
}
